import CourseGuide from '@components/LocalMerchant/Common/CourseGuide'
import { getMerchantInfo, isNewOpen } from '@util'
import React, { Component } from 'react'
import OtherCategory from './OtherCategory'
import WeddingPlanning from './WeddingPlanning'
import WorksCase from './WorksCase'
export default class extends Component {
  CategoryPlate = () => {
    const property_id =
      this.props.location.query.propertyId ?? getMerchantInfo().property_id
    const props = {
      ...this.props,
      type: 'case',
      propertyId: property_id,
      draftId: this.props.location.query.draftId || ''
    }

    const PROPERTY = {
      '2': <WeddingPlanning {...props} />, // 婚礼策划
      '6': <OtherCategory {...props} />, // 婚纱摄影
      '7': <WorksCase {...props} />, // 婚礼摄影
      '8': <WorksCase {...props} />, // 婚礼摄像
      '9': <OtherCategory {...props} />, // 婚礼跟妆
      '11': <WorksCase {...props} />, // 婚礼司仪
      '12': <OtherCategory {...props} />, // 婚纱礼服
      '13': <OtherCategory {...props} />, // 婚宴酒店
      '14': <OtherCategory {...props} />, // 婚戒首饰
      '15': <OtherCategory {...props} /> // 花艺甜品
    }
    return PROPERTY[property_id] ?? null
  }

  render() {
    return (
      <>
        {this.CategoryPlate()}
        {isNewOpen() && <CourseGuide taskId="3" />}
      </>
    )
  }
}
